var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockOpenFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.326 16.538h6.508c.882 0 1.313-.437 1.313-1.394v-5.018c0-.834-.335-1.278-1.012-1.374V6.879c0-1.716 1.1-2.625 2.379-2.625 1.278 0 2.372.91 2.372 2.625v1.517c0 .417.246.623.56.623.301 0 .54-.185.54-.623V7.022c0-2.577-1.688-3.82-3.472-3.82-1.791 0-3.48 1.243-3.48 3.82v1.716l-5.571.014c-.882 0-1.45.43-1.45 1.374v5.018c0 .957.431 1.394 1.313 1.394z"
  })));
}

export default __webpack_public_path__ + "static/media/lock-open-fill.8e8d3789.svg";
export { SvgLockOpenFill as ReactComponent };